/* Nibby cart timer: counts down from the first time the cart had items. At 0:00 the cart is
   really cleared (/cart/clear.js) and the drawer + cart bubble re-render. The end time is kept in
   localStorage, so reloading the page does not restart the clock. Emptying the cart resets it. */
(function () {
  if (customElements.get('nibby-cart-timer')) return;
  var KEY = 'nibby_cart_timer_end';

  function getEnd() { try { return parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function setEnd(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} }
  function clearEnd() { try { localStorage.removeItem(KEY); } catch (e) {} }

  var clearing = false;
  function clearCart(expiredText) {
    if (clearing) return;
    clearing = true;
    clearEnd();
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () { return fetch('/?sections=cart-drawer,cart-icon-bubble'); })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; };
        var drawer = document.getElementById('CartDrawer');
        var drawerHtml = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
        if (drawer && drawerHtml !== null) drawer.innerHTML = drawerHtml;
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.add('is-empty');
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = sections['cart-icon-bubble'] && parse(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;
        if (expiredText && drawer) {
          var note = document.createElement('p');
          note.className = 'nibby-cart-timer__expired';
          note.textContent = expiredText;
          var inner = drawer.querySelector('.drawer__inner-empty, .drawer__inner');
          if (inner) inner.prepend(note);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nibby-cart-timer' });
        }
        if (location.pathname === '/cart') location.reload();
      })
      .catch(function () {})
      .finally(function () { clearing = false; });
  }

  class NibbyCartTimer extends HTMLElement {
    connectedCallback() {
      var minutes = parseInt(this.dataset.minutes, 10) || 10;
      var now = Date.now();
      var end = getEnd();
      if (!end) { end = now + minutes * 60000; setEnd(end); }
      this.end = end;
      this.clock = this.querySelector('[data-timer-clock]');
      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      var left = Math.max(0, Math.round((this.end - Date.now()) / 1000));
      var m = Math.floor(left / 60), s = left % 60;
      if (this.clock) this.clock.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0) {
        clearInterval(this.interval);
        clearCart(this.dataset.expiredText);
      }
    }
  }
  customElements.define('nibby-cart-timer', NibbyCartTimer);

  /* Reset the clock when the cart becomes empty, so the next add starts a fresh 10 minutes. */
  function checkEmpty() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (c.item_count === 0) clearEnd();
    }).catch(function () {});
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'nibby-cart-timer') checkEmpty(); });
  }
})();
